<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <action-form v-if="project && trajectory && milestone" :id="id" :project="project" :trajectory="trajectory" :milestone="milestone" :override-endpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import ActionForm from '~/components/forms/admin/projects/action/form'

    export default {
        name: 'edit',
        props: {
            projectId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
            milestoneId: {
                required: true,
            },
            id: {
                required: true,
            },
        },

        data() {
            return {
                project: null,
                trajectory: null,
                milestone: null,
            }
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
            this.retrieveMilestone();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId }));
                this.trajectory = data;
            },

            async retrieveMilestone() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId }));
                this.milestone = data;
            },
        },

        components: {
            'action-form': ActionForm,
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.milestones.actions.store', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>